<template>
  <v-col>
    <!-- <v-window v-model="step"> -->
    <!-- USF Exempt -->
    <div>
      <v-row>
        <v-col cols="12">
          <div class="text-h4">Are you exempt from USF charges?</div>
        </v-col>

        <v-col cols="12">
          <v-radio-group v-model="formData.usf_charge">
            <template v-slot:label>
              <div>
                How can I be exempt from <strong>USF</strong>?
                <MoreInfoToolTip msg="If your company files the FCC Form 499-A and pays
                      USF contributions directly to the USF as a provider of telecommunications,
                      your company may qualify for an exemption from USF pass-through charges
                      that we impose on USF-assessable services." />
              </div>
            </template>
            <v-radio value="exempt">
              <template v-slot:label>
                <div>Yes, I am exempt from USF charges</div>
              </template>
            </v-radio>
            <v-radio value="not_exempt">
              <template v-slot:label>
                <div>No, I am not exempt from USF charges</div>
              </template>
            </v-radio>
            <v-radio value="unknown">
              <template v-slot:label>
                <div>I'm not sure right now</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </div>

    <template v-if="!isExistingCustomer && isRetail">
      <!-- State Exempt -->
      <div>
        <v-row>
          <v-col cols="12">
            <div class="text-h4">Are you exempt from state taxes?</div>
          </v-col>

          <v-col cols="12">
            <v-radio-group v-model="formData.statetax">
              <template v-slot:label>
                <div>
                  Let us know if you are <strong>State tax exempt</strong>
                </div>
              </template>
              <v-radio value="exempt">
                <template v-slot:label>
                  <div>Yes, I am exempt from state taxes</div>
                </template>
              </v-radio>
              <v-radio value="not_exempt">
                <template v-slot:label>
                  <div>No, I am not exempt from state taxes</div>
                </template>
              </v-radio>
              <v-radio value="unknown">
                <template v-slot:label>
                  <div>I'm not sure right now</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </div>

      <!-- Federal Excise Taxes -->
      <div>
        <v-row>
          <v-col cols="12">
            <div class="text-h4">Are you exempt from Federal charges?</div>
          </v-col>

          <v-col cols="12">
            <v-radio-group v-model="formData.fedtax">
              <template v-slot:label>
                <div>
                  Let us know if you are <strong>Federal tax exempt</strong>
                </div>
              </template>
              <v-radio value="exempt">
                <template v-slot:label>
                  <div>Yes, I am exempt from Federal charges</div>
                </template>
              </v-radio>
              <v-radio value="not_exempt">
                <template v-slot:label>
                  <div>No, I am not exempt from Federal charges</div>
                </template>
              </v-radio>
              <v-radio value="unknown">
                <template v-slot:label>
                  <div>I'm not sure right now</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </div>

      <!-- MI ACCESS Charges -->
      <div>
        <v-row>
          <v-col cols="12">
            <div class="text-h4">Are you exempt from MI Access charges?</div>
          </v-col>

          <v-col cols="12">
            <v-radio-group v-model="formData.stateaccess_charge">
              <template v-slot:label>
                <div>
                  Let us know if you are <strong>MI Access tax exempt</strong>
                </div>
              </template>
              <v-radio value="exempt">
                <template v-slot:label>
                  <div>Yes, I am exempt from MI Access charges</div>
                </template>
              </v-radio>
              <v-radio value="not_exempt">
                <template v-slot:label>
                  <div>No, I am not exempt from MI Access charges</div>
                </template>
              </v-radio>
              <v-radio value="unknown">
                <template v-slot:label>
                  <div>I'm not sure right now</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </div>

      <!-- MI 911 Fees -->
      <div>
        <v-row>
          <v-col cols="12">
            <div class="text-h4">Are you exempt from MI 911 fees?</div>
          </v-col>

          <v-col cols="12">
            <v-radio-group v-model="formData.emergency_fee">
              <template v-slot:label>
                <div>
                  Let us know if you are <strong>MI 911 fee exempt</strong>
                </div>
              </template>
              <v-radio value="exempt">
                <template v-slot:label>
                  <div>Yes, I am exempt from MI 911 fees</div>
                </template>
              </v-radio>
              <v-radio value="not_exempt">
                <template v-slot:label>
                  <div>No, I am not exempt from MI 911 fees</div>
                </template>
              </v-radio>
              <v-radio value="unknown">
                <template v-slot:label>
                  <div>I'm not sure right now</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </div>
    </template>
    <!-- </v-window> -->
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MoreInfoToolTip from '@/components/menus/MoreInfoToolTip.vue';

export default {
  name: 'Taxes',
  components: { MoreInfoToolTip },
  data: () => ({
    step: 0,
    formData: {
      usf_charge: '',
      statetax: '',
      fedtax: '',
      stateaccess_charge: '',
      emergency_fee: '',
    },
  }),
  mounted() {
    // set store form data
    const vm = this;
    const generalData = vm.getFormData.general;
    console.log(vm.isRetail);
    let usfCharge = generalData.usf_charge || 'not_exempt';
    if (!vm.isRetail && generalData.usfCharge != null) {
      if (vm.hasUsfWaiver) {
        usfCharge = 'exempt';
      } else {
        usfCharge = 'not_exempt';
      }
    }

    vm.formData = {
      usf_charge: usfCharge,
      statetax: generalData.statetax,
      fedtax: generalData.fedtax,
      stateaccess_charge: generalData.stateaccess_charge,
      emergency_fee: generalData.emergency_fee,
    };
    console.log(vm.formData);

    this.hijackStepper((goRight) => {
      if ((vm.step === 0 && !goRight) || (vm.step === vm.maxStep && goRight)) {
        vm.unHijackStepper();
        vm.nextSubTab(goRight);
      }
      vm.step += goRight ? 1 : -1;
    });
  },
  computed: {
    ...mapGetters(['getFormData', 'isExistingCustomer', 'isRetail', 'hasUsfWaiver']),
    maxStep() {
      return 0;
    },
  },
  methods: {
    ...mapActions([
      "updateStoreFormData",
      "hijackStepper",
      "unHijackStepper",
      "nextSubTab",
    ]),
    registerFormChange(val) {
      const keys = Object.keys(val);
      keys.forEach((key) => {
        this.updateStoreFormData({
          data: val[key],
          main: 'general',
          sub: key,
        });
      });
    },
  },
  watch: {
    formData: {
      handler(val) {
        this.registerFormChange(val);
      },
      deep: true,
    },
  },
};
</script>
